export const loadInitializeOneDS = () => import(/* webpackChunkName: "4-feat-initialize-one-ds" */ './initializeOneDS');

export const loadReportOneDSEvent = () =>
  import(/* webpackChunkName: "4-feat-report-one-ds-event" */ './reportOneDSEvent');
